const initialExpenses = [
  {
    id: 1,
    title: "Painkillers",
    amount: 25,
    category: "Exp/ Health"
  },
  {
    id: 2,
    title: "Groceries 1st week",
    amount: 254.85,
    category: "Exp/ Groceries"
  },
  {
    id: 3,
    title: "New smartwatch",
    amount: 599,
    category: "Exp/ Hobby"
  },
  {
    id: 4,
    title: "Monthly transportation ticket",
    amount: 150,
    category: "Exp/ Transport"
  }
];

export default initialExpenses;
